module.exports = __webpack_public_path__ + "static/media/undraw_business_decisions_gjwy.f35da48d.svg";